import { useState, type ReactNode } from "react"
import { Alert, type AlertProps } from "react-bootstrap"

type BannerProps = AlertProps & {
	children?: ReactNode
}

const Banner = ({ children, ...rest }: BannerProps): ReactNode => {
	const [show, setShow] = useState(true)

	return (
		<>
			{show && (
				<Alert onClose={() => setShow(false)} {...rest}>
					{children ?? "TEXT"}
				</Alert>
			)}
		</>
	)
}

export default Banner
